import { Download, RefreshCw } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface InstallSubmitButtonProps {
  installing: boolean
  disabled: boolean
}

export function InstallSubmitButton({
  installing,
  disabled,
}: InstallSubmitButtonProps): React.ReactElement {
  const { t } = useTranslation('admin')
  return (
    <div className="pt-4">
      <button
        type="submit"
        disabled={disabled}
        className="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-[#5c6e94] px-4 py-3 text-sm font-medium text-white transition-colors hover:bg-[#5c6e94] disabled:opacity-50"
      >
        {installing ? (
          <>
            <RefreshCw className="h-4 w-4 animate-spin" />
            {t('velociraptorSettings.install.installing')}
          </>
        ) : (
          <>
            <Download className="h-4 w-4" />
            {t('velociraptorSettings.install.installButton')}
          </>
        )}
      </button>
    </div>
  )
}
